import type { DeepString } from "@/lib/i18n";

export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyContent: "Strona nie zawiera jeszcze treści.",
} as const;

export type CDedicatedDescriptivePageTranslations = DeepString<typeof pl>;
